var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 12.2345C12.2344 12.9684 12.3789 13.6951 12.6598 14.3732C12.9406 15.0512 13.3523 15.6673 13.8712 16.1862C14.3902 16.7052 15.0062 17.1168 15.6843 17.3977C16.3623 17.6785 17.089 17.8231 17.8229 17.8231C18.5568 17.8231 19.2835 17.6785 19.9616 17.3977C20.6396 17.1168 21.2557 16.7052 21.7746 16.1862C22.2936 15.6673 22.7052 15.0512 22.9861 14.3732C23.2669 13.6951 23.4115 12.9684 23.4115 12.2345C23.4115 11.5006 23.2669 10.7739 22.9861 10.0959C22.7052 9.41786 22.2936 8.80179 21.7746 8.28284C21.2557 7.7639 20.6396 7.35225 19.9616 7.0714C19.2835 6.79055 18.5568 6.646 17.8229 6.646C17.089 6.646 16.3623 6.79055 15.6843 7.0714C15.0062 7.35225 14.3902 7.7639 13.8712 8.28284C13.3523 8.80179 12.9406 9.41786 12.6598 10.0959C12.3789 10.7739 12.2344 11.5006 12.2344 12.2345Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1163 53.5898V40.1773H6.64551V27.3348C9.81434 24.7899 13.7584 23.4055 17.8226 23.4116C22.052 23.4116 25.9372 24.8803 28.9997 27.3348V32.3824M24.5288 53.5898V40.1773",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2354 38.5161H51.3541V51.9286H31.2354V38.5161Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7649 38.5163V37.3986C45.7649 36.2128 45.2939 35.0757 44.4554 34.2372C43.617 33.3988 42.4798 32.9277 41.2941 32.9277C40.1083 32.9277 38.9712 33.3988 38.1327 34.2372C37.2943 35.0757 36.8232 36.2128 36.8232 37.3986V38.5163",
    stroke: "#D41E4D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsManagement);
export default __webpack_public_path__ + "static/media/DevOps_Management.8f8c5187d12118b5e3b58438b64bf76c.svg";
export { ForwardRef as ReactComponent };